import React from 'react'

const BoxEnergy = ({title, desc, image, style}) => {
  return (
    <div className="bg-white rounded-[14px] shadow-md shadow-gray-400 w-full px-[20px] py-[15px] ">
      <h1 className="font-medium text-center">{title}</h1>
      <p className={`text-center ${style} text-[14px]`}>{image}</p>
      <h1 className="font-semibold text-[24px] text-center mt-[3px]">{desc}</h1>

    </div>
  );
}

export default BoxEnergy